import { createContext, useContext } from 'react';
import { usePermissions } from '../hooks/usePermissions';

const PermissionsContext = createContext(null);

export function PermissionsProvider({ children }) {
  const perms = usePermissions();
  return (
    <PermissionsContext.Provider value={perms}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissionsContext() {
  const ctx = useContext(PermissionsContext);
  if (!ctx) throw new Error('usePermissionsContext must be used within PermissionsProvider');
  return ctx;
}
